module.exports = __webpack_public_path__ + "resources/img/img-deep-security-01-1.5e58fef299a8239045275b6b7c4d7882.png";